/* eslint-disable no-empty-pattern */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-target-blank */
import React, { useCallback, useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";

import { AppAlert } from "../../../../components/dialogue/Dialogue";
import { useAppSelector } from "../../../../redux/hooks";
import { MaterialItemsTable } from "./MaterialItemsTable";
import {
  setMaterialItems,
  setMaterialMeasurements,
  setTags,
} from "../../../../redux/reducers";
import { Container } from "../../../../globalstyled";
import AppLoader from "../../../../components/loader";
import {
  useFetchMaterialMeasurements,
  useFetchMaterials,
  useFetchTags,
} from "../../../../apolloClient/hooks/itemCreation/fetchHooks";

interface MaterialItemsProp {
  permissions?: boolean;
}

const MaterialMeasurement: React.FC<MaterialItemsProp> = ({permissions}) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const dispatch = useDispatch();

  const userReducer = useAppSelector((state) => state.userReducer);
  const { materialItems, materialMeasurements, tags } = userReducer;

  const { loading, error, materialsData, refetch } = useFetchMaterials({
    limit: 100,
    offset: 0,
  });

  const {
    loading: materialMeasurementsLoading,
    error: materialMeasurementsError,
    materialMeasurementsData,
  } = useFetchMaterialMeasurements({
    limit: 100,
    offset: 0,
    isSkip: materialMeasurements.length === 0 ? false : true,
  });

  const {
    loading: tagsLoading,
    error: tagsError,
    tags: tagsData,
  } = useFetchTags({
    limit: 100,
    offset: 0,
    isSkip: tags.length === 0 ? false : true,
  });

  const handleRefetch = useCallback(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    onFetchMaterial();

    if (materialMeasurements.length === 0) {
      onFetchMaterialMeasurements();
    }

    if (tags.length === 0) {
      onFetchTags();
    }
  }, [loading, error, materialsData, tagsLoading, tagsError, tagsData, dispatch, handleRefetch]);

  const onFetchMaterial = async () => {
    if (!loading && !error && materialsData) {
      dispatch(setMaterialItems(materialsData));
      setIsLoading(false);
    } else if (error) {
      console.error("Error fetching Material misc field:", error);
      setIsLoading(false);
    }
  };

  const onFetchMaterialMeasurements = () => {
    if (
      !materialMeasurementsLoading &&
      !materialMeasurementsError &&
      materialMeasurementsData
    ) {
      dispatch(setMaterialMeasurements(materialMeasurementsData));
      setIsLoading(false);
    } else if (error) {
      console.error("Error fetching Material measurement :", error);
      setIsLoading(false);
    }
  };

  const onFetchTags = () => {
    if (
      !tagsLoading &&
      !tagsError &&
      tagsData
    ) {
      dispatch(setTags(tagsData));
      setIsLoading(false);
    } else if (tagsError) {
      console.error("Error fetching Tags:", tagsError);
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <AppLoader isLoading={isLoading} />;
  }

  const hostContainer = () => {
    return (
      <Container>
        <AppAlert
          open={false}
          title={`Reset Password!`}
          message={"Are you sure to Reset Your Password?"}
          onClose={() => {}}
          onConfirm={() => {}}
        />
        <MaterialItemsTable
          materialItemsData={materialItems}
          refetchMaterials={handleRefetch}
          materialMeasurementIds={materialMeasurements}
          tagsData={tags}
          permissions={permissions}
        />
      </Container>
    );
  };

  return hostContainer();
};

export default MaterialMeasurement;
